<template>
  <div class="main-layout">
    <AppHeader />
    <main class="main-content">
      <div class="content-container">
        <router-view />
      </div>
    </main>
    <AppFooter />
    <FeedbackButton />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import FeedbackButton from '@/components/FeedbackButton.vue'
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-secondary);
}

.main-content {
  flex: 1;
  padding: 84px var(--spacing-md) var(--spacing-md);
}

.content-container {
  width: 100%;
}

@media (max-width: 768px) {
  .main-content {
    padding: var(--spacing-sm) 0;
  }
}
</style>
